import {
  BusinessRegistrationAddressModel,
  BusinessRegistrationAddressDto,
  BusinessRegistrationDetailsDto,
  BusinessRegistrationDetailsModel,
  BusinessRegistrationDto,
  BusinessRegistrationModel,
  BusinessRegistrationRepresentativeDto,
  BusinessRegistrationRepresentativeModel,
  BusinessRegistrationAddressesDto,
  BusinessRegistrationAddressesModel,
  BusinessRegistrationProfileDto,
  BusinessRegistrationProfileModel,
} from '../types/business-registration'

export const transformBusinessDetailsToDto = (
  model: BusinessRegistrationDetailsModel,
): BusinessRegistrationDetailsDto => ({
  legal_code: model.legalCode,
  vat: model.isVatDisabled || model.vat === '' ? undefined : model.vat,
  legal_name: model.legalName,
  entity_type: model.entityType,
  registrar_name: model.registrarName,
})

export const transformBusinessAddressToDto = (
  model: BusinessRegistrationAddressModel,
): BusinessRegistrationAddressDto => ({
  postal_code: model.fullPostalCode || model.postalCode,
  city: model.city,
  country_id: model.countryId ? Number(model.countryId) : null,
  line1: model.line1,
  line2: model.line2,
})

export const transformBusinessRepresentativeToDto = (
  model: BusinessRegistrationRepresentativeModel,
): BusinessRegistrationRepresentativeDto => ({
  full_name: model.fullName,
  birthday: model.birthday,
  nationality: model.nationality.code,
  country: model.country.code,
  first_names: model.firstNames,
  last_name: model.lastName,
  email: model.email,
  legal_representative_address:
    model.isSameLegalRepresentativeAddress || !model.legalRepresentativeAddress
      ? undefined
      : transformBusinessAddressToDto(model.legalRepresentativeAddress),
})

export const transformBusinessAddressesToDto = (
  model: BusinessRegistrationAddressesModel,
): BusinessRegistrationAddressesDto => ({
  business_address: model.businessAddress && transformBusinessAddressToDto(model.businessAddress),
  legal_representative_address:
    model.isSameLegalRepresentativeAddress || !model.legalRepresentativeAddress
      ? undefined
      : transformBusinessAddressToDto(model.legalRepresentativeAddress),
})

export const transformBusinessProfileToDto = (
  model: BusinessRegistrationProfileModel,
): BusinessRegistrationProfileDto => ({
  photo_temp_uuid: model.photoTempUuid,
  business_account_name: model.businessAccountName,
  phone_number: model.phoneNumber,
  personal_phone_number: model.isPhoneNumberPersonal,
  email: model.email,
  personal_email: model.isEmailPersonal,
})

export const transformBusinessRegistrationToDto = (
  model: Partial<BusinessRegistrationModel>,
): BusinessRegistrationDto => ({
  business_details: model.businessDetails && transformBusinessDetailsToDto(model.businessDetails),
  business_representative:
    model.businessRepresentative &&
    transformBusinessRepresentativeToDto(model.businessRepresentative),
  addresses: model.addresses && transformBusinessAddressesToDto(model.addresses),
  profile: model.profile && transformBusinessProfileToDto(model.profile),
})
